import { render, staticRenderFns } from "./calendar-day-picker.vue?vue&type=template&id=1b471d3f&scoped=true&"
import script from "./calendar-day-picker.vue?vue&type=script&lang=ts&"
export * from "./calendar-day-picker.vue?vue&type=script&lang=ts&"
import style0 from "./calendar-day-picker.vue?vue&type=style&index=0&id=1b471d3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b471d3f",
  null
  
)

export default component.exports